import { render } from "./StudentsTable.vue?vue&type=template&id=f392b10e&scoped=true"
import script from "./StudentsTable.vue?vue&type=script&lang=js"
export * from "./StudentsTable.vue?vue&type=script&lang=js"

import "./StudentsTable.vue?vue&type=style&index=0&id=f392b10e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f392b10e"]])

export default __exports__